import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37e5a6d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "mainMenu",
  class: "main-menu"
}
const _hoisted_2 = { class: "button-container pl-1" }
const _hoisted_3 = { class: "main-menu-logo-mobile" }
const _hoisted_4 = { class: "button-container justify-content-end" }
const _hoisted_5 = { class: "main-menu-icons d-flex justify-content-center" }
const _hoisted_6 = {
  key: 0,
  class: "w-100 hidden-print"
}
const _hoisted_7 = { class: "usp-bar-item" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "usp-text-small" }
const _hoisted_10 = { class: "usp-text-small" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  height: "46.45",
  width: "253.08"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#main-logo" })
], -1))
const _hoisted_12 = { class: "sidebar" }
const _hoisted_13 = { class: "main-list p-1 mb-0" }
const _hoisted_14 = ["href", "title"]
const _hoisted_15 = { class: "sub-list p-1 mb-0" }
const _hoisted_16 = ["href", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_font_awesome_layers_text = _resolveComponent("font-awesome-layers-text")!
  const _component_font_awesome_layers = _resolveComponent("font-awesome-layers")!
  const _component_Carousel = _resolveComponent("Carousel")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_LanguageDropdown = _resolveComponent("LanguageDropdown")!
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_MainSearchBar = _resolveComponent("MainSearchBar")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_MainUserMenu = _resolveComponent("MainUserMenu")!
  const _component_ChangeCompanyModal = _resolveComponent("ChangeCompanyModal")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["menu-bar", { 'border-bottom': _ctx.isMenuCollapsed, 'px-1': _ctx.isTablet }])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Button, {
            class: "p-button-text p-button-primary p-button-rounded",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isMenuCollapsed = !_ctx.isMenuCollapsed))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, {
                icon: ['far', 'bars'],
                size: "lg"
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("img", {
              style: {"cursor":"pointer"},
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openUrl(_ctx.layoutStore.vm.homePageUrl)))
            }, null, 512), [
              [_directive_lazy, '/Static/images/cadacgroup-logo-mobile.svg']
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_font_awesome_icon, {
              class: _normalizeClass({ 'text-primary': _ctx.layoutStore.showSearchBar }),
              icon: ['far', 'magnifying-glass'],
              title: _ctx.$t('menu.button.search_title'),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSearchToggle($event)))
            }, null, 8, ["class", "title"]),
            (_ctx.layoutStore.vm.itemsInCart)
              ? (_openBlock(), _createBlock(_component_font_awesome_layers, {
                  key: 0,
                  class: "fa-fw fa-2x",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onCartClick()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['far', 'cart-shopping'],
                      title: _ctx.$t('menu.button.cart_title')
                    }, null, 8, ["title"]),
                    _createVNode(_component_font_awesome_layers_text, {
                      class: "fa-layers-counter",
                      transform: "up-1 right-15",
                      value: _ctx.layoutStore.vm.itemsInCart
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 1,
                  icon: ['far', 'cart-shopping'],
                  title: _ctx.$t('menu.button.cartEmpty_title')
                }, null, 8, ["title"])),
            _createVNode(_component_font_awesome_icon, {
              icon: _ctx.layoutStore.isAuthenticated ? ['fas', 'circle-user'] : ['fas', 'user'],
              title: _ctx.$t('menu.button.userMenu_title'),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onToggleUserMenuClick($event)))
            }, null, 8, ["icon", "title"])
          ])
        ])
      ], 2)
    ], 512),
    (_ctx.layoutStore.vm.uspBlock.items && 
		 _ctx.layoutStore.vm.uspBlock.items.length && 
		 _ctx.layoutStore.vm.uspBlock.isVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_Carousel, {
            "autoplay-interval": 5000,
            circular: "",
            class: "usp-bar",
            "num-scroll": 2,
            "num-visible": 2,
            "responsive-options": _ctx.responsiveOptions,
            "show-indicators": false,
            "show-navigators": false,
            value: _ctx.layoutStore.vm.uspBlock.items
          }, {
            item: _withCtx((item) => [
              _createElementVNode("div", _hoisted_7, [
                (item.data.uspCollectionLink)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: item.data.uspCollectionLink.url
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        class: "usp-icon",
                        icon: item.data.uspIcon
                      }, null, 8, ["icon"]),
                      _createTextVNode(" " + _toDisplayString(item.data.uspCollectionTitle) + " ", 1),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(item.data.uspSubText), 1)
                    ], 8, _hoisted_8))
                  : _createCommentVNode("", true),
                (!item.data.uspCollectionLink)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_font_awesome_icon, {
                        class: "usp-icon",
                        icon: item.data.uspIcon
                      }, null, 8, ["icon"]),
                      _createTextVNode(" " + _toDisplayString(item.data.uspCollectionTitle) + " ", 1),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(item.data.uspSubText), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["responsive-options", "value"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Sidebar, {
      visible: _ctx.isMenuCollapsed,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isMenuCollapsed) = $event)),
      "base-z-index": 1000,
      dismissable: true,
      position: _ctx.isTablet ? 'left' : 'full',
      "show-close-icon": true
    }, {
      header: _withCtx(() => [
        _hoisted_11
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("ul", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layoutStore.vm.mainMenuItems, (menuItem) => {
              return (_openBlock(), _createElementBlock("li", {
                key: menuItem,
                class: "p-ripple h4"
              }, [
                _createElementVNode("a", {
                  href: menuItem.url,
                  title: menuItem.title
                }, _toDisplayString(menuItem.label), 9, _hoisted_14)
              ]))
            }), 128))
          ]),
          _createVNode(_component_Divider),
          _createElementVNode("ul", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layoutStore.vm.subMenuItems, (menuItem) => {
              return (_openBlock(), _createElementBlock("li", {
                key: menuItem,
                class: "p-ripple h6"
              }, [
                _createElementVNode("a", {
                  href: menuItem.url,
                  title: menuItem.title
                }, _toDisplayString(menuItem.label), 9, _hoisted_16)
              ]))
            }), 128))
          ]),
          _createVNode(_component_LanguageDropdown, {
            languages: _ctx.layoutStore.vm.availableLanguageOptions,
            "update-cookie": "",
            "use-full-width": ""
          }, null, 8, ["languages"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "position"]),
    _createVNode(_component_OverlayPanel, {
      ref: "searchMenuPanel",
      "append-to": ".main-menu",
      breakpoints: { '960px': '75vw', '640px': '100vw' },
      class: "main-menu-overlay",
      style: { width: '450px' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_MainSearchBar, {
          vm: _ctx.layoutStore.vm
        }, null, 8, ["vm"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_OverlayPanel, {
      ref: "userMenuPanel",
      "append-to": ".main-menu",
      class: "main-menu-overlay",
      dismissable: true,
      "show-close-icon": false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_MainUserMenu, {
          vm: _ctx.layoutStore.vm
        }, null, 8, ["vm"])
      ]),
      _: 1
    }, 512),
    (_ctx.layoutStore.changeCompanyModalVisible)
      ? (_openBlock(), _createBlock(_component_ChangeCompanyModal, {
          key: 1,
          vm: _ctx.layoutStore.vm.organizationOptions
        }, null, 8, ["vm"]))
      : _createCommentVNode("", true)
  ], 64))
}